import { createSelector } from '@reduxjs/toolkit';
import { selectReportsState } from '../../store/selectors';

export const selectTemplates = createSelector(selectReportsState, (reportTemplates) => reportTemplates.templates);
